
// src/web/components/home-groups-page.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import connect from '../../connects/home-groups-page'
import {
  Panel,
  Layout,
  Sidebar,
} from 'react-toolbox/lib/layout'
import {
  Button,
} from 'react-toolbox/lib/button'
import HomeGroupsNav from './home-groups-nav.jsx'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import Loading from './loading.jsx'
import { InfiniteScroll, InviewSensor } from './infinite-scroller';
import twoColumnLayoutTheme from './themes/two-column-layout.css'
import oneColumnLayoutTheme from './themes/one-column-layout.css'
import Diary from './diary.jsx'
import GroupMemberIcons from './group-member-icons.jsx'
import RightSidebar from './right-sidebar.jsx'

class HomeGroupsPage extends PureComponent {
  state = { responses: [], reviewTarget: undefined }
  loadMore = ()=> this.props.fetchDiaries(this.props)
  loader = (<div style={{ width: '100%', textAlign: 'center'}}>
              <ProgressBar type='circular' mode='indeterminate' multicolor />
            </div>)

  onReplyScrollFrom = (offset)=> {
    //COMMENT_FORM_HEIGHTはコメントフォームの高さ
    const COMMENT_FORM_HEIGHT = 222
    //返信コメントへの返信の場合、コメントフォームまでスクロールする
    this.refs.panel && ((ReactDOM.findDOMNode(this.refs.panel)).scrollTop += offset + COMMENT_FORM_HEIGHT)　
  }
  openSearchDrawer = () => this.props.updateUI({ openDrawer: !this.props.ui.openDrawer })
  setReviewTarget = (target)=> this.setState({ reviewTarget: target })
  render() {
    const {
      t,
      ui,
      updateUI,
      diaries,
      user,
      isFetching,
      isFetchFailed,
      isRightSidebar,
      hasMore,
      params,
      location,
      fetchDiaries,
      children,
      likeConfig,
    } = this.props
    const parentTheme = isRightSidebar ? twoColumnLayoutTheme: oneColumnLayoutTheme

    return (
      <Panel style={{ height: '100vh',  position: 'fixed' }}>
        <HomeGroupsNav openSearchDrawer={this.openSearchDrawer} openDrawer={ui.openDrawer}/>
        <Layout theme={parentTheme}>
          <Panel bodyScroll theme={parentTheme} style={{ left: 0 }} ref="panel">
            {!diaries && isFetching &&
              <Loading />
            }

            <InfiniteScroll pageStart={0}
                hasMore={hasMore && !isFetchFailed}
                initialLoad={false}
                loadMore={this.loadMore}
                loader={diaries && this.loader}
                useWindow={false} >
              {diaries && diaries.map((diary)=> 
                <Diary key={diary.diary_id} diary={diary} user={user} onReplyScrollFrom={this.onReplyScrollFrom} likeConfig={likeConfig} openSidePage={isRightSidebar} chatGptReview={this.state.responses} clearGptReview={this.clearGptReview} sendChatGPT={this.sendMessage} reviewTarget={this.state.reviewTarget} setReviewTarget={this.setReviewTarget}/>
              ) || []}
            </InfiniteScroll>
            {diaries && diaries.length == 0 && !hasMore && !isFetchFailed &&
              <div style={{ padding: '20px' }}>
                {t('label:投稿がありません')}
              </div>
            }
            {diaries && diaries.length > 0 && !hasMore && !isFetchFailed &&
              <div style={{ fontSize: '80%', padding: '0 20px', color: '#999' }}>{t('label:一番最後の投稿です')}</div>
            }
            {isFetchFailed &&
              <div style={{ padding: '20px' }}>
                <div style={{ fontSize: '90%', marginBottom: '10px' }}>
                  {t('error:読み込みに失敗しました')}
                </div>
                <Button raised
                  onClick={()=> fetchDiaries(this.props, true)}
                  label={t('label:再読み込み')}
                  style={{ width: '100%' }}/>
              </div>
            }
          </Panel>

          {isRightSidebar && 
            <Sidebar theme={twoColumnLayoutTheme} pinned scrollY width={50}>
              <RightSidebar user={user}>
                {children}
              </RightSidebar>
            </Sidebar>
          }
        </Layout>
      </Panel>
    )
  }
}

export const RawHomeGroupsPage = HomeGroupsPage
export default connect(HomeGroupsPage)



// WEBPACK FOOTER //
// ./src/web/components/home-groups-page.jsx